// frontend/src/components/layout/TopNavigationBar.jsx
import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthContext"; // TWO dots for relative path
import Icon from '../common/Icon';
import UserAvatar from '../user/UserAvatar';
import DropdownMenu from '../common/DropdownMenu';
import SearchBar from '../search/SearchBar'; // RE-ADDED: Import SearchBar
import { PATHS } from '../../router.jsx';
import './TopNavigationBar.css';

const TopNavigationBar = ({ className = '' }) => {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.log("Logout action initiated (conceptual)");
    await logout();
    navigate(PATHS.LOGIN);
  };

  const userMenuItems = user ? [
    { label: 'My Profile', iconName: 'user', onClick: () => navigate(PATHS.PROFILE(user.username)) },
    { label: 'Settings', iconName: 'settings', onClick: () => navigate('/settings') },
    { label: 'Bookmarks', iconName: 'bookmark-outline', onClick: () => navigate('/bookmarks') },
    { isSeparator: true },
    { label: 'Logout', iconName: 'logout-outline', onClick: handleLogout, className: 'dropdown-item-danger' },
  ] : [];

  return (
    <nav className={`top-navigation-bar ${className}`} role="banner" aria-label="Primary site header">
      <div className="top-nav-section top-nav-left">
        <Link to={PATHS.HOME} className="app-logo-link" aria-label="Go to homepage">
          <Icon name="logo-Z" size={28} className="app-logo-icon" />
          <span className="app-name">Z</span>
        </Link>
      </div>

      <div className="top-nav-section top-nav-center">
        {/* RE-ADDED: SearchBar component as the global trigger */}
        <SearchBar
          isGlobalTrigger={true} // This is the key prop to activate the modal trigger mode
          placeholder="Search Z..."
          size="small" // Visual size for the top navigation bar
          showSubmitButton={false} // Global triggers typically don't show a submit button
          className="top-nav-search-bar-instance" // Optional: for specific styling of this instance
          // IMPORTANT: The SearchBar itself will handle opening the modal via its internal state
          // and navigating to PATHS.GLOBAL_SEARCH when clicked, as configured in SearchBar.jsx.
        />
      </div>

      <div className="top-nav-section top-nav-right">
        {isAuthenticated && user ? (
          <>
            {/* Chat icon remains in Top Nav */}
            <NavLink to={PATHS.CHAT_LIST} className="icon-button nav-action-icon" title="Messages" aria-label="View messages">
              <Icon name="message-square" size={22} />
            </NavLink>

            <DropdownMenu
              trigger={
                <button className="user-menu-trigger-button icon-button" aria-label="User menu">
                  <UserAvatar user={user} size="small" />
                </button>
              }
              items={userMenuItems}
              position="bottom-right"
            />
          </>
        ) : (
          <>
            <NavLink to={PATHS.LOGIN} className="nav-action-button login-button">Login</NavLink>
            <NavLink to={PATHS.REGISTER} className="nav-action-button register-button primary">
              Sign Up
            </NavLink>
          </>
        )}
      </div>
    </nav>
  );
};

export default TopNavigationBar;
